<p-select [ngModel]="country" name="country" [disabled]="mode !== DetailMode.EDITION"
          (ngModelChange)="countryChange.emit($event)" (onClear)="countryChange.emit(null)"
          [options]="countries" [optionLabel]="filterLabelField" dataKey="id"
          [filter]="true" [filterBy]="filterLabelField" appendTo="body"
          [showClear]="true" i18n-placeholder="@@common-none" placeholder="(none)"
          [required]="required" class="acted-highlight-req metadata-field" [tabindex]="tabindex">
</p-select>
